import { allocationTypes, regions } from '@/repositories/devdata';

export default ({
  namespaced: true,
  state: {
    allocationTypes: [],    
    regions: []
  },
  mutations: {
    initialized(state, { allocationTypes, regions }) {
      state.allocationTypes = allocationTypes;
      state.regions = regions;
    }
  },
  actions: {
    initialize({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit('initialized', {
            allocationTypes: allocationTypes,
            regions: regions
          });
          resolve();
        }
        catch (e) {
          console.error(e);
          reject();
        }
      });
    }
  },
  getters: {
    allocationTypes(state) {
      // Convert allocationTypes array to object with key/values
      return state.allocationTypes.reduce((accumulator, currentValue) =>
      {
        accumulator[currentValue.key] = currentValue.label; 
        return accumulator; 
      }, {});
    },
    allocationTypesReport(state) {
      // Convert allocationTypes array to object with key/values
      return state.allocationTypes;
    },
    regions(state) {
      // Convert allocationTypes array to object with key/values
      return state.regions;
    }
  }
});
